export default __webpack_public_path__ + "static/media/vivino.1582674c.svg";